import type { ViewElementState } from "@ae/domain";

/**
 * Welke viewState-entries van het actieve diagram horen bij de geselecteerde
 * tabel-rijen? Een rij is één concept of één relatie, maar op het diagram kan
 * datzelfde object meerdere keren staan (canonieke key = id, extra instances
 * met een UUID-key + `ref`). "Van diagram verwijderen" vanuit de tabel haalt
 * álle instances op dit diagram weg — de rij verdwijnt dan ook echt.
 *
 * Relatie-keys staan los van de concept-keys: de caller verbergt eerst de
 * relaties en daarna de concepten (hideConceptOnDiagram neemt afhankelijke
 * relatie-instances zelf mee; een relatie die al weg is, zou anders een
 * `hidden`-marker krijgen).
 */
export function diagramEntryKeysForRows(
  viewState: Readonly<Record<string, ViewElementState>>,
  conceptIds: readonly string[],
  relationIds: readonly string[],
): { conceptKeys: string[]; relationKeys: string[] } {
  const concepts = new Set(conceptIds);
  const relations = new Set(relationIds);
  const conceptKeys: string[] = [];
  const relationKeys: string[] = [];
  for (const [key, ve] of Object.entries(viewState)) {
    const ref = ve.ref ?? key;
    if (ve.hidden === true) continue; // staat al niet (meer) op het diagram
    if (ve.position !== undefined) {
      if (concepts.has(ref)) conceptKeys.push(key);
    } else if (ve.type !== "object" && relations.has(ref)) {
      relationKeys.push(key);
    }
  }
  return { conceptKeys, relationKeys };
}
